import { useState, useEffect } from 'react';
import { useParams, Link } from 'react-router-dom';
import SEOHead from '@/components/feature/SEOHead';
import Breadcrumb from '@/components/base/Breadcrumb';
import { categories } from '@/mocks/categories';
import { articles, getArticlesByCategory } from '@/mocks/articles';

const categoryImageUrls: Record<string, string> = {
  'product-updates': 'https://readdy.ai/api/search-image?query=Modern%20minimalist%20software%20update%20concept%20with%20clean%20interface%20mockup%2C%20warm%20cream%20background%2C%20subtle%20geometric%20patterns%2C%20tech%20aesthetic%2C%20soft%20lighting&width=800&height=400&seq=cat-product-updates&orientation=landscape',
  'tutorials': 'https://readdy.ai/api/search-image?query=Open%20book%20with%20minimalist%20learning%20concept%2C%20clean%20warm%20cream%20background%2C%20knowledge%20and%20education%20theme%2C%20soft%20natural%20lighting%2C%20elegant%20composition&width=800&height=400&seq=cat-tutorials&orientation=landscape',
  'efficiency-tips': 'https://readdy.ai/api/search-image?query=Minimalist%20productivity%20concept%20with%20paper%20airplane%20and%20clean%20desk%2C%20warm%20cream%20background%2C%20zen%20workspace%2C%20soft%20natual%20lighting%2C%20elegant%20simple%20composition&width=800&height=400&seq=cat-efficiency&orientation=landscape',
  'industry-news': 'https://readdy.ai/api/search-image?query=Minimalist%20news%20and%20trends%20concept%20with%20data%20visualization%2C%20warm%20cream%20background%2C%20clean%20infographic%20style%2C%20modern%20business%20aesthetic%2C%20soft%20lighting&width=800&height=400&seq=cat-industry&orientation=landscape',
};

const allImageUrl = 'https://readdy.ai/api/search-image?query=Minimalist%20grid%20of%20diverse%20content%20cards%2C%20warm%20cream%20background%2C%20clean%20modern%20layout%2C%20soft%20natural%20lighting%2C%20elegant%20editorial%20design&width=800&height=400&seq=cat-all&orientation=landscape';

const hardcodedImageUrls: Record<string, string> = {
  'nana-lite-launch': 'https://readdy.ai/api/search-image?query=Minimalist%20lightweight%20app%20on%20a%20clean%20white%20desk%20with%20soft%20natural%20lighting%2C%20elegant%20and%20simple%20design%2C%20warm%20cream%20background%2C%20editorial%20product%20photography%20with%20gentle%20shadows&width=800&height=400&seq=article-launch&orientation=landscape',
  'boost-productivity-with-nana-lite': 'https://readdy.ai/api/search-image?query=Modern%20workspace%20with%20laptop%20showing%20minimalist%20productivity%20app%20interface%2C%20warm%20ambient%20lighting%2C%20clean%20desk%20setup%20with%20notebook%20and%20coffee%2C%20soft%20cream%20and%20wood%20tones&width=800&height=400&seq=article-productivity&orientation=landscape',
  'lite-vs-full-comparison': 'https://readdy.ai/api/search-image?query=Side%20by%20side%20comparison%20of%20two%20smartphone%20app%20interfaces%2C%20one%20minimalist%20one%20comprehensive%2C%20clean%20white%20background%2C%20soft%20shadow%2C%20modern%20UI%20design%20aesthetic&width=800&height=400&seq=article-comparison&orientation=landscape',
  'hidden-features': 'https://readdy.ai/api/search-image?query=Smartphone%20showing%20hidden%20gesture%20features%20of%20a%20minimalist%20app%2C%20warm%20cream%20background%2C%20soft%20natural%20light%2C%20clean%20modern%20photography%20style&width=800&height=400&seq=article-hidden-features&orientation=landscape',
  'installation-guide': 'https://readdy.ai/api/search-image?query=Laptop%20screen%20showing%20app%20installation%20process%20with%20progress%20bar%2C%20clean%20modern%20desk%20setup%2C%20warm%20ambient%20lighting%2C%20minimalist%20workspace%20aesthetic&width=800&height=400&seq=article-installation&orientation=landscape',
  'minimalist-workflow': 'https://readdy.ai/api/search-image?query=Clean%20minimalist%20desk%20with%20a%20notebook%20and%20a%20phone%20displaying%20productivity%20app%2C%20morning%20sunlight%20through%20window%2C%20warm%20cream%20and%20beige%20tones%2C%20zen%20atmosphere&width=800&height=400&seq=article-minimalist-workflow&orientation=landscape',
  'industry-trends-lightweight-apps': 'https://readdy.ai/api/search-image?query=Futuristic%20minimalist%20data%20visualization%20chart%20showing%20upward%20trend%2C%20warm%20cream%20background%20with%20clean%20geometric%20patterns%2C%20modern%20infographic%20style%2C%20soft%20lighting&width=800&height=400&seq=article-industry-trends&orientation=landscape',
  'nana-lite-mobile-guide': 'https://readdy.ai/api/search-image?query=Smartphone%20in%20hand%20displaying%20minimalist%20app%20interface%20on%20a%20clean%20cafe%20table%2C%20morning%20light%2C%20warm%20cream%20and%20wood%20tones%2C%20lifestyle%20product%20photography&width=800&height=400&seq=article-mobile-review&orientation=landscape',
  'efficiency-methods-comparison': 'https://readdy.ai/api/search-image?query=Three%20productivity%20method%20cards%20laid%20out%20on%20a%20clean%20desk%2C%20GTD%20tomato%20timer%20and%20quadrant%20diagram%2C%20warm%20cream%20background%2C%20minimalist%20flat%20lay%20photography&width=800&height=400&seq=article-efficiency-methods&orientation=landscape',
  'team-collaboration-lite': 'https://readdy.ai/api/search-image?query=Small%20team%20of%20three%20people%20collaborating%20around%20a%20laptop%20in%20a%20bright%20modern%20office%2C%20warm%20neutral%20tones%2C%20natural%20light%2C%20genuine%20interaction&width=800&height=400&seq=article-team-collab&orientation=landscape',
  'security-privacy-nana-lite': 'https://readdy.ai/api/search-image?query=Abstract%20digital%20security%20concept%20with%20lock%20icon%20and%20shield%2C%20warm%20cream%20background%20with%20subtle%20geometric%20patterns%2C%20minimalist%20tech%20illustration%20style&width=800&height=400&seq=article-security&orientation=landscape',
  'user-story-freelancer': 'https://readdy.ai/api/search-image?query=Freelancer%20working%20happily%20in%20a%20cozy%20home%20office%20with%20laptop%20and%20warm%20lighting%2C%20plants%20on%20desk%2C%20relaxed%20authentic%20atmosphere%2C%20cream%20and%20wood%20interior&width=800&height=400&seq=article-user-story&orientation=landscape',
};

export default function CategoryPage() {
  const { slug } = useParams<{ slug: string }>();
  const [activeCategory, setActiveCategory] = useState(slug || 'all');

  useEffect(() => {
    if (slug) setActiveCategory(slug);
  }, [slug]);

  const currentCategory = categories.find((c) => c.slug === activeCategory) || categories[0];
  const filteredArticles = getArticlesByCategory(activeCategory);

  const pageTitle = activeCategory === 'all'
    ? '全部文章 — 娜娜轻量版'
    : `${currentCategory.name} — 娜娜轻量版`;

  const pageDescription = activeCategory === 'all'
    ? '浏览娜娜轻量版全部文章，涵盖产品动态、使用教程、效率技巧和行业资讯。'
    : currentCategory.description;

  const pageKeywords = activeCategory === 'all'
    ? '娜娜轻量版,文章,教程,效率,轻量版,产品动态'
    : `娜娜轻量版,${currentCategory.name},轻量版应用,效率工具`;

  const breadcrumbItems = [
    { label: '首页', href: '/' },
    { label: '文章分类', href: '/category/all' },
  ];
  if (activeCategory !== 'all') {
    breadcrumbItems.push({ label: currentCategory.name });
  } else {
    breadcrumbItems.push({ label: '全部文章' });
  }

  const categoryJsonLd = [
    {
      '@context': 'https://schema.org',
      '@type': 'WebPage',
      name: pageTitle,
      description: pageDescription,
      url: `https://www.nanalite.com/category/${activeCategory}`,
    },
    {
      '@context': 'https://schema.org',
      '@type': 'BreadcrumbList',
      itemListElement: breadcrumbItems.map((item, i) => ({
        '@type': 'ListItem',
        position: i + 1,
        name: item.label,
        item: item.href ? `https://www.nanalite.com${item.href}` : undefined,
      })),
    },
  ];

  return (
    <>
      <SEOHead
        title={pageTitle}
        description={pageDescription}
        keywords={pageKeywords}
        canonicalUrl={`https://www.nanalite.com/category/${activeCategory}`}
        jsonLd={categoryJsonLd}
      />
      <main className="min-h-screen pt-16">
        <div className="max-w-7xl mx-auto px-4 md:px-6">
          <Breadcrumb items={breadcrumbItems} />

          <div className="py-8">
            <h1 className="text-2xl md:text-3xl font-bold font-heading text-foreground-950">
              {currentCategory.name}
            </h1>
            <p className="mt-2 text-foreground-600 text-sm">{currentCategory.description}</p>
          </div>

          <div className="flex items-center gap-2 pb-6 overflow-x-auto flex-wrap">
            {categories.map((cat) => (
              <Link
                key={cat.slug}
                to={`/category/${cat.slug}`}
                className={`flex items-center gap-1.5 px-4 py-2 rounded-full text-sm font-medium whitespace-nowrap transition-colors duration-200 ${
                  activeCategory === cat.slug
                    ? 'bg-primary-500 text-background-50'
                    : 'bg-background-100 text-foreground-600 hover:bg-background-200/70'
                }`}
              >
                <i className={`${cat.icon} text-xs`}></i>
                {cat.name}
              </Link>
            ))}
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 pb-16">
            {filteredArticles.map((article) => (
              <Link
                key={article.slug}
                to={`/article/${article.slug}`}
                className="group block rounded-2xl bg-background-100 overflow-hidden border border-background-200/70 hover:border-primary-200/60 transition-colors duration-200"
              >
                <div className="h-48 overflow-hidden">
                  <img
                    src={hardcodedImageUrls[article.slug]}
                    alt={article.title}
                    title={`${article.title} - 娜娜轻量版`}
                    className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                  />
                </div>
                <div className="p-5">
                  <div className="flex items-center gap-3 mb-3">
                    <span className="text-xs text-foreground-500">{article.date}</span>
                    <span className="text-xs px-2 py-0.5 rounded-full bg-accent-100 text-accent-700">
                      {article.readTime}
                    </span>
                  </div>
                  <h2 className="text-base font-semibold text-foreground-950 mb-2 line-clamp-2 group-hover:text-primary-500 transition-colors">
                    {article.title}
                  </h2>
                  <p className="text-sm text-foreground-600 leading-relaxed line-clamp-2">{article.excerpt}</p>
                </div>
              </Link>
            ))}
          </div>

          {filteredArticles.length === 0 && (
            <div className="text-center py-20">
              <div className="w-16 h-16 mx-auto flex items-center justify-center rounded-2xl bg-background-100 text-foreground-400 mb-4">
                <i className="ri-inbox-line text-2xl"></i>
              </div>
              <p className="text-foreground-500">该分类下暂无文章</p>
            </div>
          )}
        </div>
      </main>
    </>
  );
}